import { GridColDef } from "@mui/x-data-grid";
import CampaignJob from "../interfaces/campaignJob";
import { GridRenderCellParams } from "@mui/x-data-grid";
import GridCellButtonWrapper from "../components/baseComponents/gridCellButtonWrapper";

const getCampaignJobsColumnDef = (handleCampaignJobRowClick: (row: CampaignJob) => void): GridColDef[] => [
    {
        field: 'campaign_job_id',
        headerName: 'Job ID',
        width: 150,
        renderCell: (params: GridRenderCellParams<CampaignJob, any, any>) => {
            return (
                <GridCellButtonWrapper onClick={() => handleCampaignJobRowClick(params.row)} text={params.row.campaign_job_id} />
            );
        }
    },
    { field: 'campaign_name', headerName: 'Campaign Name', width: 150 },
    { field: 'campaign_type', headerName: 'Campaign Type', width: 150 },
    { field: 'campaign_config_name', headerName: 'Campaign Config Name', width: 150 },
    { field: 'original_filename', headerName: 'File Name', width: 150 },
    { field: 'total_rows', headerName: 'Total Rows', width: 150 },
    { field: 'pool_month', headerName: 'Pool Month', width: 150 },
    { field: 'created_date', headerName: 'Created Date', width: 150 },
    { field: 'created_by', headerName: 'Created By', width: 150 },
];

export default getCampaignJobsColumnDef;